var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayPartical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0835 6.22194V1.77735C1.0835 1.41069 1.0835 1.22735 1.16058 1.11902C1.19388 1.07222 1.2365 1.03281 1.28576 1.00327C1.33502 0.973729 1.38986 0.954692 1.44683 0.947354C1.57891 0.930687 1.74058 1.01652 2.0635 1.18902L6.23016 3.4111L6.23183 3.41194C6.58891 3.60235 6.76766 3.69777 6.82641 3.82444C6.87725 3.93527 6.87725 4.06319 6.82641 4.17402C6.76766 4.3011 6.5885 4.39694 6.23058 4.58777L2.06391 6.80985C1.74016 6.98235 1.57891 7.06819 1.44725 7.05152C1.3902 7.04424 1.33529 7.02523 1.28595 6.99568C1.23662 6.96614 1.19393 6.9267 1.16058 6.87985C1.0835 6.77152 1.0835 6.5886 1.0835 6.22194Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayPartical);
export default __webpack_public_path__ + "static/media/playPartical.5132f6c459434f46c78420cb8bc29d92.svg";
export { ForwardRef as ReactComponent };